import styled from 'styled-components'

export const PillsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 25px 0;
`
